<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Create web information</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t(`addNewContactsModal.close`)"
          ></button>
        </div>
        <div class="modal-body">
          <div class="text-start m-2 custom-input">
            <div class="row">
              <div class="col-12 mb-3 whitebg-input">
                <label class="form-label bold-12 text-gray"> Title </label>
                <input class="form-control" v-model="asset.title" />
              </div>
              <div class="col-12 mb-3 whitebg-input">
                <label class="form-label bold-12 text-gray">
                  Description
                </label>
                <input class="form-control" v-model="asset.description" />
              </div>
              <div class="col-12 mb-3 whitebg-input">
                <label class="form-label bold-12 text-gray"> Start at </label>
                <input
                  class="form-control"
                  type="datetime-local"
                  v-model="asset.start_at"
                />
              </div>
              <div class="col-12 mb-3 whitebg-input">
                <label class="form-label bold-12 text-gray"> End at </label>
                <input
                  class="form-control"
                  type="datetime-local"
                  v-model="asset.end_at"
                />
              </div>
              <div class="col-12 mb-3 whitebg-input">
                <label class="form-label bold-12 text-gray"> Languange </label>
                <v-select
                  :options="languages"
                  :filterable="false"
                  v-model="asset.language_code"
                  label="name"
                  :placeholder="$t(`assetFinder.addANewItem`)"
                  :reduce="(c) => c.language_code"
                  append-to-body
                />
              </div>
              <div class="col-12 mb-3 whitebg-input">
                <label class="form-label bold-12 text-gray">
                  Sale channel
                </label>
                <v-select
                  :options="webshops"
                  :filterable="false"
                  v-model="asset.webshop_id"
                  label="name"
                  :placeholder="$t(`assetFinder.addANewItem`)"
                  :reduce="(c) => c.id"
                  append-to-body
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            v-on:click="addAsset"
            :class="{ 'loading-spin': loadAddBtn }"
            :disabled="loadAddBtn"
          >
            {{ $t("finance.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../modules/http";
import { useStore } from "vuex";
const bootstrap = require("bootstrap");

export default {
  name: "NewWebInformation",
  props: {
    modelValue: Object,
    statuses: Array,
  },
  emits: ["update:modelValue", "add"],
  data() {
    return {
      myModal: undefined,
      success: false,
      loadAddBtn: false,
      asset: {},
    };
  },
  computed: {
    languages() {
      const store = useStore();
      return store.state.languages;
    },
    webshops() {
      const store = useStore();
      return store.state.webshops;
    },
  },
  methods: {
    showModal() {
      if (this.myModal === undefined) {
        this.myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }
      this.myModal.show();
    },
    addAsset() {
      this.loadAddBtn = true;
      http
        .fetch("/web/informations", this.asset, true)
        .then((data) => {
          this.loadAddBtn = false;
          this.myModal.hide();
          this.$emit("add", data.row);
        })
        .catch(() => {
          this.loadAddBtn = false;
        });
    },
  },
  components: {},
};
</script>
